import { useEffect } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";

// Components
import CategoryMobileItem from "components/molecules/CategoryMobileItem";

// Constants
import {
  CATEGORIES,
  CATEGORIES_ENUMS,
  POPULAR_CATEGORIES,
} from "constants/navigation/categories";

import "swiper/css";
import "./styles.sass";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../redux/auth/selectors";

type CategoryMobileProps = {
  isLocalizationLoaded: boolean;
  onSelect: (category: CATEGORIES_ENUMS) => void;
};

const CategoryMobile = (props: CategoryMobileProps) => {
  const { isLocalizationLoaded, onSelect } = props;
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  const swiper = useSwiper();

  useEffect(() => {
    if (swiper && isLocalizationLoaded) {
      swiper.init();
    }
  }, [swiper, isLocalizationLoaded]);

  const listCategory = POPULAR_CATEGORIES.concat(CATEGORIES);
  return (
    <div className="CategoryMobile">
      {isLocalizationLoaded && (
        <Swiper spaceBetween={8} slidesPerView="auto" freeMode init={false}>
          {listCategory.map((category) => {
            if (!isAuthenticated && category.id === CATEGORIES_ENUMS.FAVORITE) {
              return null;
            }
            if (isAuthenticated && category.id === CATEGORIES_ENUMS.SPORT) {
              return null;
            }

            return (
              <SwiperSlide key={category.id}>
                <CategoryMobileItem
                  key={category.id}
                  item={category}
                  // eslint-disable-next-line react/jsx-handler-names
                  onSelect={onSelect}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </div>
  );
};

export default CategoryMobile;
